/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_WebpInputs */

const en_val_webp = /** @type {(inputs: Val_WebpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`WEBP`)
};

const es_val_webp = /** @type {(inputs: Val_WebpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`WEBP`)
};

const fr_val_webp = /** @type {(inputs: Val_WebpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`WEBP`)
};

const de_val_webp = /** @type {(inputs: Val_WebpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`WEBP`)
};

const ja_val_webp = /** @type {(inputs: Val_WebpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`WEBP`)
};

const zh_val_webp = /** @type {(inputs: Val_WebpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`WEBP`)
};

const ar_val_webp = /** @type {(inputs: Val_WebpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`WEBP`)
};

const id_val_webp = /** @type {(inputs: Val_WebpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`WEBP`)
};

const it_val_webp = /** @type {(inputs: Val_WebpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`WEBP`)
};

const ru_val_webp = /** @type {(inputs: Val_WebpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`WEBP`)
};

const pt_val_webp = /** @type {(inputs: Val_WebpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`WEBP`)
};

const ko_val_webp = /** @type {(inputs: Val_WebpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`WEBP`)
};

/**
* | output |
* | --- |
* | "WEBP" |
*
* @param {Val_WebpInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_webp = /** @type {((inputs?: Val_WebpInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_WebpInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_webp(inputs)
	if (locale === "es") return es_val_webp(inputs)
	if (locale === "fr") return fr_val_webp(inputs)
	if (locale === "de") return de_val_webp(inputs)
	if (locale === "ja") return ja_val_webp(inputs)
	if (locale === "zh") return zh_val_webp(inputs)
	if (locale === "ar") return ar_val_webp(inputs)
	if (locale === "id") return id_val_webp(inputs)
	if (locale === "it") return it_val_webp(inputs)
	if (locale === "ru") return ru_val_webp(inputs)
	if (locale === "pt") return pt_val_webp(inputs)
	return ko_val_webp(inputs)
});